import { Link } from "react-router-dom";
import { formatMiles, formatPrice } from "@/lib/company";

const StatusBadge = ({ status }) => {
  const sold = status !== "Available";
  return (
    <span
      className={`text-[11px] font-semibold uppercase tracking-wide px-2 py-1 rounded ${
        sold ? "bg-amber-100 text-amber-800" : "bg-green-100 text-green-800"
      }`}
    >
      {status}
    </span>
  );
};

export const VehicleCard = ({ v }) => {
  return (
    <div
      className="group border border-slate-200 bg-white rounded-sm overflow-hidden flex flex-col hover:border-slate-400 transition-colors"
      data-testid={`vehicle-card-${v.stock_number}`}
    >
      <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden">
        <img
          src={v.images[0]}
          alt={`${v.year} ${v.make} ${v.model}`}
          className="h-full w-full object-cover"
          loading="lazy"
        />
        <span className="absolute top-2 left-2 bg-slate-900/85 text-white text-[11px] font-mono px-2 py-1 rounded">
          Stock #{v.stock_number}
        </span>
      </div>

      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="text-base font-bold text-slate-900 leading-snug">
            {v.year} {v.make} {v.model}
          </h3>
        </div>
        <div className="text-xl font-extrabold text-blue-800 mt-1">{formatPrice(v.price)}</div>

        <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-sm text-slate-600">
          <div><dt className="inline text-slate-400">Mileage: </dt><dd className="inline">{formatMiles(v.mileage)}</dd></div>
          <div><dt className="inline text-slate-400">Fuel: </dt><dd className="inline">{v.fuel_type}</dd></div>
          <div><dt className="inline text-slate-400">Color: </dt><dd className="inline">{v.exterior_color}</dd></div>
          <div><dt className="inline text-slate-400">Trans: </dt><dd className="inline">{v.transmission}</dd></div>
        </dl>

        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs text-slate-500">{v.condition}</span>
          <StatusBadge status={v.availability} />
        </div>

        <Link
          to={`/catalog/${v.stock_number}`}
          data-testid={`vehicle-details-btn-${v.stock_number}`}
          className="mt-4 inline-flex justify-center items-center rounded-sm border border-blue-800 px-4 py-2.5 text-sm font-semibold text-blue-800 hover:bg-blue-800 hover:text-white transition-colors"
        >
          View Details
        </Link>
      </div>
    </div>
  );
};
